module.exports = __webpack_public_path__ + "static/media/Montserrat-MediumItalic.b3ddbb16.eot";